import { atom } from 'recoil';
import { ITag } from '#types/tags';

const ATOM_KEY = 'selectedcoachtag';

export const $selectedCoachTagState = atom<ITag>({
  key: ATOM_KEY,
  default: { id: 'all', name: '전체' }
});
